import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app';
import { env } from './env';
import { Providers } from './Providers';
import { initSentry } from './sentry/init';

window.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('app');

  if (!container) {
    throw new Error('Root element not found');
  }

  initSentry(env.VITE_WEBAPP_ENV, env.VITE_WEBAPP_RELEASE);

  createRoot(container).render(
    <StrictMode>
      <Providers>
        <App />
      </Providers>
    </StrictMode>,
  );
});
